import React from 'react';
import {
  Grid,
  TextField,
} from '@mui/material';
import { ContactFormData } from './validation';

interface OptionalFieldsProps {
  formData: ContactFormData;
  errors: Partial<Record<keyof ContactFormData, string>>;
  onChange: (field: keyof ContactFormData) => (event: React.ChangeEvent<HTMLInputElement | { value: unknown }>) => void;
}

export const OptionalFields: React.FC<OptionalFieldsProps> = ({
  formData,
  errors,
  onChange
}) => {
  return (
    <>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Secondary Phone"
          value={formData.secondaryPhone}
          onChange={onChange('secondaryPhone')}
          error={!!errors.secondaryPhone}
          helperText={errors.secondaryPhone}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Home Address"
          value={formData.address}
          onChange={onChange('address')}
          multiline
          rows={2}
        />
      </Grid>

      {/* <Grid item xs={12} sm={6}>
        <FormControl fullWidth>
          <InputLabel>Preferred Contact Method</InputLabel>
          <Select
            value={formData.preferredContact}
            label="Preferred Contact Method"
            onChange={onChange('preferredContact')}
          >
            <MenuItem value="phone">Phone</MenuItem>
            <MenuItem value="email">Email</MenuItem>
            <MenuItem value="text">Text</MenuItem>
          </Select>
        </FormControl>
      </Grid> */}

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Language Preference"
          value={formData.language}
          onChange={onChange('language')}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Occupation/Employer"
          value={formData.occupation}
          onChange={onChange('occupation')}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Available Contact Hours"
          value={formData.availableHours}
          onChange={onChange('availableHours')}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Special Instructions/Notes"
          value={formData.notes}
          onChange={onChange('notes')}
          multiline
          rows={3}
        />
      </Grid>
    </>
  );
};